import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import callEach from "./utilities/callEach";

var LoginManager = /*#__PURE__*/function () {
  function LoginManager(service) {
    var _this = this;

    _classCallCheck(this, LoginManager);

    this.onChangeCallbacks = [];
    this.service = service;
    this.service.onChange(function () {
      callEach(_this.onChangeCallbacks, _this);
    });
  } // Event handlers


  _createClass(LoginManager, [{
    key: "onChange",
    value: function onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
  }, {
    key: "offChange",
    value: function offChange(cb) {
      if (this.onChangeCallbacks.includes(cb)) {
        this.onChangeCallbacks.splice(this.onChangeCallbacks.indexOf(cb), 1);
        return true;
      }

      return false;
    } // Class methods

  }, {
    key: "login",
    value: function login() {
      this.service.login();
    }
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.service.logout();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }() // Class properties

  }, {
    key: "accountOverviewUrl",
    get: function get() {
      return this.service.accountOverviewUrl;
    }
  }, {
    key: "authState",
    get: function get() {
      return this.service.authState;
    }
  }, {
    key: "cartUrl",
    get: function get() {
      return this.service.cartUrl;
    }
  }, {
    key: "itemsInCart",
    get: function get() {
      return this.service.itemsInCart;
    }
  }, {
    key: "logoutUrl",
    get: function get() {
      return this.service.logoutUrl;
    }
  }, {
    key: "loginUrl",
    get: function get() {
      return this.service.loginUrl;
    }
  }, {
    key: "userName",
    get: function get() {
      return this.service.userName;
    }
  }, {
    key: "userFirstName",
    get: function get() {
      return this.service.userFirstName;
    }
  }]);

  return LoginManager;
}();

export { LoginManager as default };